export default {
  campaign: () => import("/codebuild/output/src1120545451/src/consort-headless/nuxtapp/layouts/campaign.vue"),
  default: () => import("/codebuild/output/src1120545451/src/consort-headless/nuxtapp/layouts/default.vue")
}